import { useModal } from "../../stores/useModal"
import React, { useEffect, useState } from "react"
import { CreateGroup } from "./create-group";
import { PhoneCall } from "./phone_call";
import { Stories } from "./stories";
import { Preview } from "./preview";
import {motion} from 'framer-motion'

export const Modals = ({}) => {
    const {status, type, values, styles, 
        headed, toggle} = useModal(state=>state)
    
    useEffect(()=>{},[type])

    const modals = () => {
        switch (type) {
            case 'create-group':
                return <CreateGroup values={values} />;
            case 'preview':
                return <Preview values={values} />;
            case 'phone-call':
                return <PhoneCall values={values} />;
            case 'stories':
                return <Stories values={values} />;
            break;
            default:
            break;
        }
    }


    return  status ? (
        <React.Fragment>
        <div>
            <div class="absolute left-0 right-0 top-0 bottom-0 h-full w-full flex items-center justify-center">
                <motion.div
                   animate={{y: [-755,0]  }}
                   transition={{ ease: "easeIn" }}
                   className="z-[200]"
                >
                    <div  class="
                    w-fit h-auto rounded-md relative overflow-hidden
                    block items-center justify-center z-[200]">
                    {modals()}
                    </div>
                   
                 </motion.div>
            </div>
        <div 
        onClick={toggle}
        class="bg-white/10 dark:bg-black/10 backdrop-blur-md absolute left-0 right-0 bottom-0 top-0 z-[199]"></div>
        </div>
        </React.Fragment>
    ) : <></>
  }

